import { useParams } from "react-router-dom";
import {
  InformationBanner,
  PrimaryButton,
  SingleFileUploader,
  Spinner,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Td,
  Th,
  WarningBanner,
} from "@graffer-inc/console-design-kit";
import { ServiceProviderTemplate } from "../../../../../template/service-provider/default-template";
import { ServiceProviderR } from "../../../routes";
import { useServiceProviderSmartApplyProceduresBulkExportByCSVHooks } from "./hooks";

export const ServiceProviderSmartApplyProceduresBulkExportByCSV: React.FC =
  () => {
    const { id: tenantId } = useParams<{ id: string }>();

    const {
      isBulkExporting,
      errMsg,
      exportable,
      exportableLimit,
      csvHeaderLabels,
      csvFile,
      exportSettingRows,
      handleSetFile,
      handleDeleteFile,
      handleBulkExport,
    } = useServiceProviderSmartApplyProceduresBulkExportByCSVHooks();

    return (
      <ServiceProviderTemplate
        breadcrumbs={[
          {
            to: ServiceProviderR.Home.link({}),
            title: "Home",
          },
          {
            to: ServiceProviderR.Procedures.link({ id: tenantId }),
            title: "手続き一覧",
          },
          {
            to: ServiceProviderR.SmartApplyProceduresBulkExportByCSV.link({
              id: tenantId,
            }),
            title: "手続き一括エクスポート",
          },
        ]}
      >
        <Spinner loading={isBulkExporting} />
        <div className="columns is-vcentered">
          <div className="column has-text-left">
            <h1 className="title">手続き一括エクスポート</h1>
          </div>
        </div>
        <div className="mb-4">
          <p>
            csvファイルから手続き設定内容を一括エクスポートします。一度に出力可能な件数は最大
            {exportableLimit}件です。
            <br />
            csvファイルは以下の形式でアップロードしてください。
          </p>
        </div>
        <div className="mb-6">
          <Table borderType="all">
            <TableHeader>
              <TableRow>
                <Th rowSpan={1}>{csvHeaderLabels.originProcedureId}</Th>
                <Th rowSpan={1}>{csvHeaderLabels.originProcedureName}</Th>
                <Th rowSpan={1}>{csvHeaderLabels.destManageGroupId}</Th>
                <Th rowSpan={1}>{csvHeaderLabels.destManageGroupName}</Th>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <Td>1111111111111111111</Td>
                <Td>手続きA</Td>
                <Td>2222222222222222222</Td>
                <Td>グループA</Td>
              </TableRow>
              <TableRow>
                <Td>3333333333333333333</Td>
                <Td>手続きB</Td>
                <Td>4444444444444444444</Td>
                <Td>グループB</Td>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        {errMsg && (
          <div className="mb-4">
            <WarningBanner
              message={
                errMsg +
                "\n" +
                "csvファイルを確認し削除後再度アップロードしてください。"
              }
            />
          </div>
        )}
        <div className="mb-6">
          <SingleFileUploader
            label="csvファイル"
            description=""
            required
            acceptFileType={["text/csv"]}
            value={csvFile}
            setFile={handleSetFile}
            deleteFile={handleDeleteFile}
          />
        </div>
        {exportSettingRows.length > 0 && (
          <div className="mb-6">
            <div className="mb-4">
              <InformationBanner
                message={`エクスポート対象は${exportSettingRows.length}件です。実行前に内容を確認してください。`}
              />
            </div>
            <Table borderType="all">
              <TableHeader>
                <TableRow>
                  <Th rowSpan={1}>{csvHeaderLabels.originProcedureId}</Th>
                  <Th rowSpan={1}>{csvHeaderLabels.originProcedureName}</Th>
                  <Th rowSpan={1}>{csvHeaderLabels.destManageGroupId}</Th>
                  <Th rowSpan={1}>{csvHeaderLabels.destManageGroupName}</Th>
                </TableRow>
              </TableHeader>
              <TableBody>
                {exportSettingRows.map((r, i) => (
                  <TableRow key={`proceduresBulkExportByCSVSettingRow-${i}`}>
                    <Td>{r.originProcedureId}</Td>
                    <Td>{r.originProcedureName}</Td>
                    <Td>{r.destManageGroupId}</Td>
                    <Td>{r.destManageGroupName}</Td>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
        <PrimaryButton
          text="一括エクスポートする"
          onClick={handleBulkExport}
          disabled={!exportable || isBulkExporting}
        />
      </ServiceProviderTemplate>
    );
  };
